export class PdfDocument {
    readonly title: string = '';
    readonly url: string = '';

    constructor(title: string, url: string) {
        this.title = title;
        this.url = url;
    }

    static of(object: Record<string, string>) {
        return new PdfDocument(
            object.title,
            object.url
        )
    }

    static emptyPdfDocument() {
        return new PdfDocument(
            '',
            ''
        )
    }

}
